import React, { useEffect, useState } from 'react';
import '../../styles/perts-style/_backSlide.scss';

const FlowingImages = ({ imagesLeft, onImagesLoaded }) => {
    const [currentIndexLeft, setCurrentIndexLeft] = useState(0);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [scale, setScale] = useState(1.3);
    const [currentBreakpoint, setCurrentBreakpoint] = useState('xxl');

    // Define breakpoints matching the SCSS breakpoints
    const breakpoints = {
        xs: 380,
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1200,
        xxl: 1400,
    };

    // Define translate positions for each breakpoint
    const translatePositions = {
        xxl: { x: windowWidth * 0.9, y: windowHeight * 0.9 },
        xl: { x: windowWidth * 0.85, y: windowHeight * 0.85 },
        lg: { x: windowWidth * 0.8, y: windowHeight * 0.8 },
        md: { x: windowWidth * 0.75, y: windowHeight * 0.75 },
        sm: { x: windowWidth * 0.7, y: windowHeight * 0.7 },
        xs: { x: windowWidth * 0.65, y: windowHeight * 0.65 },
    };

    useEffect(() => {
        const intervalLeft = setInterval(() => {
            setCurrentIndexLeft((prevIndex) => (prevIndex + 1) % imagesLeft.length);
        }, 5000); // Images change every 5 seconds

        return () => {
            clearInterval(intervalLeft);
        };
    }, [imagesLeft.length]);

    useEffect(() => {
        let loadedImages = 0;
        const totalImages = imagesLeft.length;

        const handleImageLoad = () => {
            loadedImages += 1;
            if (loadedImages === totalImages) {
                onImagesLoaded(); // Notify when all images are loaded
            }
        };

        imagesLeft.forEach((image) => {
            const img = new Image();
            img.src = image;
            img.onload = handleImageLoad;
        });
    }, [imagesLeft, onImagesLoaded]);

    useEffect(() => {
        const determineBreakpoint = (width) => {
            if (width <= breakpoints.xs) return 'xs';
            if (width <= breakpoints.sm) return 'sm';
            if (width <= breakpoints.md) return 'md';
            if (width <= breakpoints.lg) return 'lg';
            if (width <= breakpoints.xl) return 'xl';
            return 'xxl';
        };

        const handleResize = () => {
            const width = window.innerWidth;
            setWindowWidth(width);
            setWindowHeight(window.innerHeight);
            
            // Determine current breakpoint
            const bp = determineBreakpoint(width);
            setCurrentBreakpoint(bp);

            // Calculate new scale based on window width
            const calculatedScale = 0.8 + ((width - 800) / 1200) * 0.5;
            const newScale = Math.max(0.8, Math.min(1.3, calculatedScale));
            setScale(newScale);
        };

        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div className="image-split-screen">
            <svg className='sp-clip' width={0} height={0}>
                <defs>
                    <mask id="clip-path">
                        <g id="" data-name="insole"
                            style={{
                                scale: '0.9',
                                transform: `translate(150px, -30px)`,
                            }}
                        >
                            <path d="M136.017 0.36772C104.376 3.18567 70.2241 21.1194 50.6017 50.7873C33.7496 72.7383 20.4468 98.6201 13.0596 129.112C-2.4652 165.297 0.636858 272.177 0.636858 272.177C0.636858 272.177 3.27722 338.897 8.16838 357.755C11.4003 379.374 16.0462 399.244 21.5289 418.074C21.5289 418.074 37.5298 463.118 39.3189 468.118C41.108 473.118 56.5318 527.771 59.1433 538.624C62.2453 551.876 68.3917 590.113 69.5171 599.593C70.6425 609.073 72.6192 629.492 72.9078 643.134C73.1963 656.775 69.95 749.45 69.95 749.45L68.1176 835.968C67.7713 853.728 68.536 868.483 71.7824 883.468C74.668 901.778 80.8721 919.22 89.2838 936.056C95.7765 948.498 103.741 959.958 114.692 970.55C124.243 979.437 143.678 989.307 147.444 990.911C151.21 992.516 168.322 999.467 179.619 1001.09C179.619 1001.09 196.702 1002.14 204.464 1001.09C212.227 1000.03 231.33 996.374 237.779 993.729C244.228 991.085 267.602 977.328 263.187 980.16C258.772 982.992 284.93 967.299 296.502 951.879C308.073 936.46 312.878 920.925 315.129 911.171C317.379 901.416 319.645 893.642 321.333 878.945C323.021 864.249 325.286 810.52 325.286 810.52L328.114 737.571L330.379 656.14L334.333 622.209L338.286 578.104L346.193 522.121L354.662 473.493L362.006 437.872L368.21 402.25L371.038 372.842L372.163 324.215L369.898 293.116L362.554 252.408C358.861 235.63 354.114 220.196 347.881 203.78L329.817 167.031C320.049 147.349 310.598 129.444 302.158 117.276C292.808 101.843 281.525 86.6113 269.406 71.4666C259.897 59.0243 248.802 47.6369 236.654 36.9721C220.999 24.4431 205.46 13.6337 190.353 9.26954C171.727 2.86774 153.561 -0.455987 136.017 0.36772Z" fill="white"/>
                        </g>
                    </mask>
                </defs>
            </svg>
            <div className="screen-clip">
                <div className="image-container">
                    {imagesLeft.map((image, index) => (
                        <img
                            key={index}
                            src={image}
                            alt={`slide-${index}`}
                            className={index === currentIndexLeft ? 'active' : ''}
                            onLoad={() => console.log(`Image ${index} loaded`)} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FlowingImages;
